// extracted by mini-css-extract-plugin
export default {"milestoneLink":"MilestoneMetadata-module__milestoneLink--LYihJ","milestoneTitleTruncate":"MilestoneMetadata-module__milestoneTitleTruncate--me4W1"};